import React from 'react';

function AnchorPreview() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="108"
      viewBox="0 0 108 108"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-1050 -1228)">
          <g transform="translate(926 1175)">
            <g transform="translate(124 53)">
              <path fill="#FFF" d="M0 0H108V108H0z" />
              <path
                fill="#EFEFEF"
                d="M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
              />
              <rect
                width="30"
                height="30"
                x="69"
                y="71"
                fill="currentColor"
                rx="4"
              />
              <path
                fill="#C5C5C5"
                fillRule="nonzero"
                d="M51.39 75.02a2.652 2.652 0 002.13-2.598V52.539h12.5c.625 0 1.25-.625 1.25-1.25 0-.45-.176-.8-.508-1.016l-.02-.02L52.758 36.25c-.899-.996-2.5-.996-3.516 0l-14.12 14.121c-.411.41-.49.86-.255 1.387.137.469.625.742 1.153.742h12.5v20c0 1.523 1.386 2.773 2.87 2.52z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default AnchorPreview;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/AnchorPreview.js